export default function getResource(label, vars = []) {
    const resources = {
        store: 'Magasin',
        edit: 'Modifier',
        pickAnArtist: 'Choisir un(e) artiste',
        anyAvailableArtist: 'Tous les artistes disponibles',
        artistAvailabilityNotice: 'L’artiste peut changer en fonction de la disponibilité ce jour-là.',
        continueToReviewAndPay: 'Continuer pour Vérifier et payer',
        pickDateAndTime: 'Choisissez une date et une heure',
        showCalendar: 'Afficher le calendrier',
        timeSlotsTooltip: 'Time slots not displayed are fully booked.',
        morning: 'Matin',
        afternoon: 'Après-midi',
        evening: 'Soir',
        before: 'Before',
        noAvailableTimes: 'Aucune heure disponible',
        pickDate: 'Pick A Date',
        done: 'Done',
        calendarMessage: `If you would like to schedule an appointment more than 90 days in advance, please call your preferred ${vars[0]}.`,
        today: 'Today'
    };

    return resources[label];
}
